<template>
  <div class="successed-box">
    <van-icon color="#3acd22" name="checked"  size="80" />
    <p class="tip">报名成功！</p>
    <div style="padding:0 20px; margin:50px 0">
        <van-button type="primary"  block  @click="go('MeetingList')">返回会议列表</van-button>
    </div>
  </div>
</template>

<script>
import { Icon, Button } from "vant";

export default {
  data() {
    return {};
  },
  components: {
    [Icon.name]: Icon,
    [Button.name]: Button
  },
  methods: {
    go(pathName) {
      this.$router.push({ name: pathName });
    }
  }
};
</script>

<style lang="less" scoped>
.successed-box {
  padding-top: 25px;
  text-align: center;
  .tip {
    font-size: 16px;
    color: #3acd22;
    margin-top:20px;
  }
  .warm {
    margin-top: 20px;
    font-size: 14px;
    color: #999;
  }
  .loginBtn {
    margin-top: 15%;
  }
}
</style>
